export enum CharityStatus {
  None,
  Cancelled,
  Declined,
  Completed,
}
